import type { CityConfig } from "../city-template/types";

export const jamestownNDConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Jamestown",
  state: "North Dakota",
  stateAbbr: "ND",
  slug: "jamestown-nd",
  route: "/cities/jamestown-nd",
  title: "Emergency Passport Jamestown, ND — Expedited Same-Day Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Jamestown, ND — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Stutsman County, UJ Jimmies, National Buffalo Museum visitors, and I-94 corridor travelers. No Minneapolis trip needed.",
  h1: "Emergency & Expedited Passport Services in Jamestown, North Dakota",
  heroSubtitle: "University of Jamestown student heading abroad for a semester? Stutsman County agribusiness professional with an overseas conference? National Buffalo Museum curator traveling internationally for a museum exchange? We help Jamestown residents — from UJ students and faculty to I-94 interstate travelers to Buffalo City families — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30-100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Jamestown%20North%20Dakota%20with%20the%20Worlds%20Largest%20Buffalo%20monument%20and%20National%20Buffalo%20Museum%20visible%20in%20the%20foreground%2C%20the%20Jamestown%20Reservoir%20shimmering%20to%20the%20north%2C%20the%20historic%20downtown%20district%20with%20Frontier%20Village%20along%20the%20James%20River%20valley%2C%20University%20of%20Jamestown%20campus%20buildings%20on%20the%20hillside%2C%20golden%20summer%20evening%20light%20across%20the%20prairie%20landscape%20with%20dramatic%20cloud%20formations%2C%20professional%20travel%20photography%20with%20crisp%20detail&width=1800&height=700&seq=jamestown-nd-hero-2026&orientation=landscape",
  heroImageAlt: "Jamestown North Dakota with World's Largest Buffalo and National Buffalo Museum",
  geoPosition: "46.9105;-98.7084",
  geoPlacename: "Jamestown, North Dakota",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Minneapolis Passport Agency",
    address: "212 3rd Ave S, Suite 200, Minneapolis, MN 55401",
    distance: "Nearest regional passport agency — located approximately 305 miles from Jamestown; about a 4.5-hour drive via I-94",
  },
  nearbyCitiesZips: [
    { name: "Jamestown", zips: "58401" },
    { name: "Valley City", zips: "58072" },
    { name: "Carrington", zips: "58421" },
    { name: "Edgeley", zips: "58433" },
    { name: "New Rockford", zips: "58356" },
    { name: "Kulm", zips: "58456" },
    { name: "LaMoure", zips: "58458" },
  ],
  benefits: [
    { icon: "ri-graduation-cap-line", title: "University of Jamestown International Programs", desc: "The University of Jamestown — North Dakota's only private liberal arts university — sends students on study abroad, international internships, and mission trips worldwide. UJ Jimmies traveling abroad for the first time need reliable, fast passport processing that fits tight academic calendars." },
    { icon: "ri-landscape-line", title: "National Buffalo Museum & Frontier Village", desc: "Jamestown is home to the National Buffalo Museum and the world-famous 'World's Largest Buffalo' monument — drawing visitors from across the globe. Museum professionals and cultural heritage staff attend international conferences and exchanges requiring fast passport turnaround." },
    { icon: "ri-road-map-line", title: "I-94 Corridor Gateway", desc: "Jamestown anchors the central I-94 corridor — exactly 100 miles from Fargo and 100 miles from Bismarck. This strategic position means Jamestown serves as a processing hub for travelers from Carrington, Edgeley, New Rockford, and the James River Valley." },
    { icon: "ri-seedling-line", title: "Stutsman County Agriculture & AgTech", desc: "Jamestown's agribusiness sector — from Stutsman County farms to regional ag equipment manufacturers — sends professionals to international trade shows, equipment expos, and agricultural exchanges across Canada, Europe, and South America." },
  ],
  internalLinks: [
    { name: "Expedited passport in Valley City, ND", route: "/cities/valley-city" },
    { name: "Fast passport services in Fargo, ND", route: "/cities/fargo" },
    { name: "Quick passport services in Bismarck, ND", route: "/cities/bismarck" },
    { name: "North Dakota passport services overview", route: "/states/north-dakota" },
  ],
  fpcOfficeAddress: "212 3rd Ave S, Suite 200, Minneapolis, MN 55401",
  fpcOfficeNote: "Fast Passport Center serves Jamestown via secure registered courier with direct access to the Minneapolis Passport Agency. Our registered couriers hand-deliver your documents — meaning you get faster results without driving 4.5+ hours to Minneapolis. Jamestown residents can ship from any UPS Store, FedEx Office, or post office location across Stutsman County.",
  fpcOfficeDistance: "Serving Jamestown, Valley City, Carrington, Edgeley, and all Stutsman County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Jamestown and Stutsman County. From the University of Jamestown campus to downtown Buffalo City, from the National Buffalo Museum to the Jamestown Reservoir — we serve the entire Jamestown region. Our courier service eliminates the need to drive 305 miles to Minneapolis.",
  nearbyCitiesIntro: "We serve Jamestown and surrounding Stutsman County communities including Valley City, Carrington, Edgeley, and New Rockford. Our service covers the central I-94 corridor and James River Valley communities.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Jamestown as simple as possible — with the reliability UJ students, Stutsman County ag professionals, and Buffalo City families deserve. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee.",
  mistakesIntro: "Jamestown's mix of UJ student needs, I-94 traveler patterns, and agricultural professional schedules creates unique passport challenges. Here are the most common mistakes we see from Stutsman County travelers.",
  testimonialsIntro: "Jamestown travelers — from University of Jamestown Jimmies to Stutsman County farm families to National Buffalo Museum staff — trust us when international travel deadlines arrive and Minneapolis is simply too far.",
  faqIntro: "Have questions about expedited passports in Jamestown, ND? Here are the most common ones we hear from Stutsman County and the I-94 corridor.",
  statePageRoute: "/states/north-dakota",
  statePageName: "North Dakota",
  servicesIntro: "Whether you need a renewal before a UJ study abroad semester, an emergency passport for a last-minute agribusiness trade show in Canada, or a first-time passport for a Stutsman County family vacation — Fast Passport Center handles it with reserved courier submission availability.",
  dmvWebsite: "https://www.dot.nd.gov/divisions/driverslicense/driverslicense.htm",
  dmvLabel: "North Dakota Department of Transportation — Driver License Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins", "Life-or-death emergencies only", "Minneapolis agency is 305 miles from Jamestown", "4.5+ hour drive — takes a full day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2-9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "No Minneapolis trip needed", "Ideal for UJ students and ag professionals", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3-5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service through post office", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1-3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "UJ semester abroad departure next week and your passport is expired? Stutsman County farmer heading to an international equipment expo with days' notice? Family emergency abroad? Our emergency courier service submits directly via reserved slots — as fast as 24 hours for Jamestown travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Jamestown residents renew fast — no agency visit required for most renewals. Perfect for UJ faculty, Stutsman County professionals, and James River Valley families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Stutsman County residents through every step with clear instructions for the nearest acceptance facility.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms like DS-64. We guide you through everything needed so your study abroad or agribusiness trip isn't derailed.",
      bullets: ["DS-64 form guidance", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Stutsman County family vacation stays on track.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or legal name change — we assist with corrected passports so travel documents match reservations and IDs.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Jamestown ND", description: "Urgent passport processing for Jamestown North Dakota travelers." },
    { name: "Expedited Passport Renewal Jamestown ND", description: "Fast passport renewal for Jamestown residents." },
    { name: "First-Time Passport Jamestown ND", description: "New passport application services for Jamestown residents." },
    { name: "Child Passport Jamestown ND", description: "Minor passport services for Jamestown families." },
    { name: "Name Change Passport Jamestown ND", description: "Name correction for Jamestown residents." },
  ],
  testimonials: [
    {
      name: "Emily K.",
      location: "Jamestown — UJ Student",
      rating: 5,
      text: "UJ nursing major — I got accepted to a medical mission trip to Honduras with a 12-day notice. My passport was expired and I was in full panic mode. Fast Passport Center expedited my renewal in 4 days. I was able to join the mission and it changed my life.",
      service: "Emergency Passport — Medical Mission",
    },
    {
      name: "Mark T.",
      location: "Jamestown",
      rating: 5,
      text: "Stutsman County farmer heading to the Agritechnica equipment expo in Germany. I travel internationally maybe once every five years so I didn't notice my passport expired during the pandemic. They renewed it in 5 days. Made the expo and found equipment that's now in our barn.",
      service: "Passport Renewal — Agribusiness Travel",
    },
    {
      name: "The Larsen Family",
      location: "Jamestown",
      rating: 5,
      text: "We planned a family trip to Norway to see where my grandparents immigrated from. Three generations — my father's first passport ever, renewals for us, and first-time applications for our kids. Fast Passport Center handled all five passports. Standing on the ancestral farm was worth every bit of planning.",
      service: "Multi-Generation Family Passports",
    },
    {
      name: "Dr. Andrea S.",
      location: "Jamestown — UJ Faculty",
      rating: 5,
      text: "University of Jamestown biology professor presenting research at an international conference in Edinburgh. My presentation date was in 2 weeks and my passport was in my office drawer — expired by 8 months. Fast Passport Center got it renewed in 4 days. Presented to a packed room of 300 colleagues.",
      service: "Expedited Passport — Academic Conference",
    },
  ],
  facilities: [
    {
      id: "jamestown-1",
      name: "Jamestown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "212 2nd St SW",
      city: "Jamestown",
      state: "ND",
      zip: "58401",
      phone: "(701) 252-3411",
      hours: "Mon-Fri 8:30 AM - 4:30 PM (appointment required)",
      distance: "Downtown Jamestown",
      website: "https://tools.usps.com/find-location.htm?location=1377964",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility for Jamestown and Stutsman County. Passport photos available on-site. Appointment recommended — limited slots during UJ academic year transitions.",
      icon: "ri-mail-line",
    },
    {
      id: "jamestown-2",
      name: "Stutsman County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "511 2nd Ave SE",
      city: "Jamestown",
      state: "ND",
      zip: "58401",
      phone: "(701) 252-9042",
      hours: "Mon-Fri 8:00 AM - 5:00 PM",
      distance: "Downtown Jamestown — Stutsman County Courthouse",
      website: "https://www.stutsmancounty.gov/",
      websiteLabel: "Stutsman County Website",
      notes: "Alternative to post office acceptance. Does not offer photo services — bring your own passport photo. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "jamestown-3",
      name: "Valley City Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "149 NE 3rd St",
      city: "Valley City",
      state: "ND",
      zip: "58072",
      phone: "(701) 845-1641",
      hours: "Mon-Fri 9:00 AM - 3:30 PM (appointment required)",
      distance: "Valley City — about 35 miles east on I-94",
      website: "https://tools.usps.com/find-location.htm?location=1388007",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility with passport photo service. About 30-minute drive from Jamestown via I-94. Good backup when Jamestown appointments are booked.",
      icon: "ri-mail-line",
    },
    {
      id: "jamestown-4",
      name: "Fargo Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "657 2nd Ave N",
      city: "Fargo",
      state: "ND",
      zip: "58102",
      phone: "(701) 241-6192",
      hours: "Mon-Fri 8:30 AM - 5:30 PM (appointment required)",
      distance: "Fargo — about 100 miles east on I-94",
      website: "https://tools.usps.com/find-location.htm?location=1372751",
      websiteLabel: "USPS Location",
      notes: "Largest acceptance facility in the region. Full passport photo and overnight shipping services. About 1.5 hours from Jamestown — useful when time permits a drive.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — Minneapolis Passport Agency, 305 miles from Jamestown", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 4.5+ hours to Minneapolis", fpc: "Most Jamestown travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission as registered courier" },
    { feature: "Practicality for Jamestown", agency: "305-mile drive — impractical for Stutsman County", fpc: "Entirely remote — ship from Jamestown, receive at your door" },
    { feature: "Cost vs Resellers", agency: "Government fees — plus travel costs and days off work", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "UJ Study Abroad Last-Minute Rush",
      description: "University of Jamestown students accepted to study abroad programs often discover expired or non-existent passports weeks before departure. First-time applicants need both an acceptance facility visit and processing time. Start the process before or alongside the program application.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Agribusiness Travel Timing Conflicts",
      description: "Stutsman County agricultural professionals travel during planting and harvest windows — which are precisely when passport processing resources are most stressed. Plan passport applications during winter months when farm operations are slower and acceptance facilities have more availability.",
    },
    {
      icon: "ri-error-warning-line",
      title: "I-94 MSP Assumptions",
      description: "Jamestown sits on I-94 with a straight shot to Minneapolis — 305 miles. Residents sometimes think they can just drive to the Minneapolis Passport Agency. The agency requires appointments for life-or-death emergencies only and driving 4.5+ hours for a potential rejection is not worth the risk.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date — whether a UJ study abroad semester, agribusiness trade show, or family heritage trip." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist tailored to your situation — UJ student, Stutsman County resident, or Buffalo City professional." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send documents using overnight shipping. Most Jamestown clients ship from the Jamestown Post Office on 2nd Street SW or drive to Fargo for UPS service." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "Your documents arrive at our center. We submit through reserved agency slots — so Jamestown travelers never need to drive 305 miles to Minneapolis." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Arrives at Your Door", description: "Your passport is shipped directly to your Jamestown address. No agency visit. No Minneapolis. Just your passport, on time." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Jamestown, North Dakota?", a: "We offer Jamestown-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5-10 business days. Because the nearest regional passport agency is Minneapolis (305 miles away), our remote courier service is the most practical fast option for Stutsman County." },
    { q: "Do I need to visit a Jamestown office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (Jamestown Post Office or Stutsman County Clerk), then ship documents overnight. We handle State Department submission and return your passport to your Jamestown address." },
    { q: "Can UJ students get expedited passports for study abroad?", a: "Yes. University of Jamestown students heading abroad for study abroad, international internships, or mission trips are among our most common Jamestown clients. We work with tight academic timelines and can process first-time and renewal passports fast." },
    { q: "Where can I get passport acceptance in Jamestown?", a: "Jamestown has acceptance at the Post Office (212 2nd St SW) and the Stutsman County Clerk (511 2nd Ave SE). The Valley City Post Office is about 35 miles east on I-94 — a good backup with more appointment availability." },
    { q: "What documents do Jamestown applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent." },
    { q: "Can I get a passport photo in Jamestown?", a: "Yes. The Jamestown Post Office offers on-site passport photos. Walmart and Walgreens in Jamestown also provide passport photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What is the best price for expedited service in Jamestown?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30-100% lower than FedEx, Staples, and other resellers. We offer a best price guarantee." },
    { q: "How does Jamestown Airport (JMS) affect passport timing?", a: "Jamestown Regional Airport (JMS) offers United flights to Denver. Your passport must be valid at JMS check-in for international connections — not just at DEN. If your passport is expired, you won't board in Jamestown. Always verify validity before heading to the airport." },
  ],
  photoLocations: [
    { name: "Jamestown Post Office", address: "212 2nd St SW, Jamestown, ND 58401", hours: "Mon-Fri 8:30 AM - 4:30 PM (photo service available)" },
    { name: "Walmart Supercenter — Jamestown", address: "921 25th St SW, Jamestown, ND 58401", hours: "Daily 6 AM - 11 PM" },
    { name: "Walgreens — Jamestown", address: "621 1st Ave S, Jamestown, ND 58401", hours: "Daily 8 AM - 10 PM" },
  ],
  dmvLocations: [
    {
      name: "ND DOT — Jamestown Driver License Office",
      address: "810 20th Ave SW, Jamestown, ND 58401",
      hours: "Mon-Fri, 8:00 AM - 4:45 PM (appointment recommended)",
      note: "Driver licenses, REAL ID, vehicle registration. Located in the Jamestown Regional Office building.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "JMS",
      name: "Jamestown Regional Airport",
      distance: "About 3 miles northeast of downtown Jamestown",
      address: "1600 6th Ave NE, Jamestown, ND 58401",
      note: "Regional airport with United flights to Denver International Airport (DEN). Daily service connecting Jamestown to major international gateways. About 5 minutes from downtown.",
      flightUrl: "https://www.jamestownnd.gov/",
      flightLabel: "Jamestown Airport Website",
      featured: true,
    },
    {
      code: "FAR",
      name: "Hector International Airport (Fargo)",
      distance: "About 100 miles east of Jamestown via I-94",
      address: "2801 32nd Ave N, Fargo, ND 58102",
      note: "Larger regional airport with daily flights to Minneapolis, Denver, Chicago, Dallas, and Phoenix. More international connection options than JMS. About 1.5 hours from Jamestown.",
      flightUrl: "https://www.fargoairport.com/",
      flightLabel: "Fargo Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Dakota birth certificates from the ND Department of Health Vital Records. Online, mail, or in-person options available in Bismarck.",
      url: "https://www.health.nd.gov/vital-records",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Stutsman County Clerk of Court. Certified copies for name changes and passport applications.",
      url: "https://www.stutsmancounty.gov/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Stutsman County District Court.",
      url: "https://www.stutsmancounty.gov/",
    },
  ],
};